let id = 0;

import {
  fishHeightCoefficient,
  fishLeftCoefficient,
  fishWidthCoefficient,
  targetWidthCoefficient,
} from './pitcyFishConstants';

export interface PierPhysicsCoordinates {
  left: number;
  targetTop: number;
  targetBottom: number;
  targetWidth: number;
  height: number;
  isOffScreen: boolean;
  id: number;
}

export class PierPhysics {
  public containerWidth: number;

  public containterHeight: number;

  private secondsPerWidth: number;

  private initialLeft: number;

  private targetTopPercent: number;

  private targetBottomPercent: number;

  private creationMoment: number;

  private id: number;

  constructor(props: {
    containerWidth: number;
    containterHeight: number;
    secondsPerWidth: number;
    targetTopPercent: number;
    targetBottomPercent: number;
  }) {
    this.containerWidth = props.containerWidth;
    this.containterHeight = props.containterHeight;
    this.secondsPerWidth = props.secondsPerWidth;
    this.targetTopPercent = props.targetTopPercent;
    this.targetBottomPercent = props.targetBottomPercent;
    this.creationMoment = Date.now();
    this.initialLeft = props.containerWidth + this.targetWidth;
    this.id = id++;
  }

  get obstacleWidth() {
    return this.containerWidth * targetWidthCoefficient;
  }

  /**
   * The Y position of the upper bound of the opening
   */
  get targetTop() {
    return this.containterHeight * this.targetTopPercent;
  }

  /**
   * The Y position of the lower bound of the opening
   */
  get targetBottom() {
    return this.containterHeight * this.targetBottomPercent;
  }

  get targetWidth() {
    return this.containerWidth * targetWidthCoefficient;
  }

  private _lastCoordinates: PierPhysicsCoordinates | undefined;

  updateCoordinates(): PierPhysicsCoordinates {
    const elapsedTime = Date.now() - this.creationMoment;
    const percentageWidthTraveled = elapsedTime / (1000 * this.secondsPerWidth);
    const pixelsTraveled = this.containerWidth * percentageWidthTraveled;
    const left = this.initialLeft - pixelsTraveled;
    this._lastCoordinates = {
      left,
      targetTop: this.targetTop,
      targetBottom: this.targetBottom,
      targetWidth: this.targetWidth,
      height: this.containterHeight,
      isOffScreen: left + this.targetWidth < 0,
      id: this.id,
    };
    return this._lastCoordinates;
  }

  getCoordinates(): PierPhysicsCoordinates {
    return this._lastCoordinates || this.updateCoordinates();
  }

  /**
   * @param fishYCoefficient - as 0-1, with 0 as lowest!!!
   * @returns whether or not there is currently a collision.
   */
  isCollision(fishYCoefficient: number) {
    fishYCoefficient = 1 - fishYCoefficient;
    const elapsedTime = Date.now() - this.creationMoment;
    const percentageWidthTraveled = elapsedTime / (1000 * this.secondsPerWidth);
    const fishLeft = fishLeftCoefficient;
    const fishRight = fishLeftCoefficient + fishWidthCoefficient;
    const pierLeftCoefficient = 1 - (percentageWidthTraveled - targetWidthCoefficient);
    const pierRightCoefficient = pierLeftCoefficient + targetWidthCoefficient;

    // Is the fish between the top and bottom openings?
    const fishBottom = fishYCoefficient;
    const fishTop = fishYCoefficient - fishHeightCoefficient;
    const openingTopCoefficient = this.targetTopPercent;
    const openingBottomCoefficient = this.targetBottomPercent;

    // console.log({
    //   percentageWidthTraveled,
    //   pierLeftCoefficient,
    //   pierRightCoefficient,
    //   openingTopCoefficient,
    //   openingBottomCoefficient,
    //   fishLeft,
    //   fishRight,
    //   fishTop,
    //   fishBottom,
    // });

    // If we don't have an x-collision, don't bother checking y.
    if (pierLeftCoefficient > fishRight) return false;
    if (pierRightCoefficient < fishLeft) return false;

    if (fishTop > openingTopCoefficient && fishBottom < openingBottomCoefficient) {
      return false;
    }

    // There's a collision!
    return true;
  }
}
